<script setup lang="ts">
import { Icon as IconifyIcon } from '@iconify/vue'

defineProps<{
  name: string
  size?: number
  color?: string
}>()
</script>

<template>
  <span :style="{ color, display: 'inline-flex', lineHeight: 0 }">
    <IconifyIcon
      :icon="`lucide:${name}`"
      :width="size ?? 16"
      :height="size ?? 16"
    />
  </span>
</template>
